import Vue from 'vue'
import Router from 'vue-router'

import AppIndex from '@index/AppIndex/AppIndex'
import WeixinReport from '@index/WeixinReport/WeixinReport'
import EventIndex from '@index/EventIndex/EventIndex'
import EventSearch from '@index/EventSearch/EventSearch'
import KeywordSearch from '@index/EventSearch/KeywordSearch'
import TagSearch from '@index/EventSearch/TagSearch'

// import EventAll from '@index/EventAll/EventAll'
import EventCenter from '@index/EventCenter/EventCenter'
// import AudiencesAnalyse from '@index/AudiencesAnalyse/AudiencesAnalyse'
import EventGeneral from '@index/EventGeneral/EventGeneral'
import EventTendency from '@index/EventTendency/EventTendency'
import EventChannel from '@index/EventChannel/EventChannel'
import EventViews from '@index/EventViews/EventViews'
import EventResponse from '@index/EventResponse/EventResponse'
// import EventTrend from '@index/EventTrend/EventTrend'
// import EventLink from '@index/EventLink/EventLink'
import EventCharge from '@index/EventCharge/EventCharge'
// import ChannelAnalyse from '@index/ChannelAnalyse/ChannelAnalyse'
// import ViewLayout from '@index/ViewLayout/ViewLayout.vue'
// import TopwordsLayout from '@index/TopwordsLayout/TopwordsLayout'
import UserCenter from '@index/UserCenter/UserCenter'
import request from '../server/server'

// import SubscribeIndex from '@index/SubscribeIndex/SubscribeIndex'
import HomePage from '@index/EventIndex/HomePage/HomePage'
// import CrisisRank from '@index/CrisisRank/CrisisRank'
import CaseCollection from '@index/CaseCollection/CaseCollection'
import CaseCompare from '@index/CaseCompare/CaseCompare'
import ReportDownload from '@index/ReportDownload/ReportDownload'
import CaliberLibrary from '@index/CaliberLibrary/CaliberLibrary'

// const Login = resolve => require(['@index/Login/Login'], resolve)
// const Register = resolve => require(['@index/Register/Register'], resolve)
// const RegisterWechat = resolve => require(['@index/Register/RegisterWechat'], resolve)
// const OpenVip = resolve => require(['@index/OpenVip/OpenVip'], resolve)
// const MyReport = resolve => require(['@index/MyReport/MyReport'], resolve)
// const MyCollect = resolve => require(['@index/MyCollect/MyCollect'], resolve)
const MyCase = resolve => require(['@index/MyCase/MyCase'], resolve)
const MyReport = resolve => require(['@index/MyReport/MyReport'], resolve)
const MyVip = resolve => require(['@index/MyVip/MyVip'], resolve)
const MyInformation = resolve => require(['@index/MyInformation/MyInformation'], resolve)
const ViewSpreadGraph = resolve => require(['@index/ViewSpreadGraph/ViewSpreadGraph'], resolve)
const comparisonResult = resolve => require(['@index/comparisonResult/comparisonResult'], resolve)
const CrisisInsight = resolve => require(['@index/CrisisInsight/CrisisInsight'], resolve)
const GraphChart = resolve => require(['@index/CrisisInsight/GraphChart'], resolve)
const sss = resolve => require(['@index/CrisisInsight/sss'], resolve)
const CrisisTopic = resolve => require(['@index/CrisisTopic/CrisisTopic'], resolve)
const CrisisTopicDetails = resolve => require(['@index/CrisisTopicDetails/CrisisTopicDetails'], resolve)
const CrisisDetails = resolve => require(['@index/CrisisDetails/CrisisDetails'], resolve)
const ShareLayout = resolve => require(['@index/ShareLayout/ShareLayout'], resolve)
// const MyMessage = resolve => require(['@index/MyMessage/MyMessage'], resolve)
// const ReportCustomMade = resolve => require(['@index/ReportCustomMade/ReportCustomMade'], resolve)
// const MiniTools = resolve => require(['@index/MiniTools/MiniTools'], resolve)
// const BillManager = resolve => require(['@index/BillManager/BillManager'], resolve)

const PdfViewer = resolve => require(['@index/components/PdfViewer'], resolve)
const CrisisChart = resolve => require(['@index/CrisisChart/CrisisChart'], resolve)
// const ReportDownload = resolve => require(['@index/ReportDownload/ReportDownload'], resolve)
// const PasswordRetrieve = resolve => require(['@index/PasswordRetrieve/PasswordRetrieve'], resolve)

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/AppIndex',
      name: 'AppIndex',
      component: AppIndex,
      meta: {
        title: '',
        requireAuth: false
      }
    }, // 移动端访问
    // {
    //   path: '/insight',
    //   name: 'CrisisInsight',
    //   component: CrisisInsight,
    //   meta: {
    //     tilte: '',
    //     requiresAuth: false
    //   }
    // },
    {
      path: '/WeixinReport',
      name: 'WeixinReport',
      component: WeixinReport,
      meta: {
        title: '',
        requireAuth: false
      }
    }, // 微信报告
    {
      path: '/insight',
      name: 'CrisisInsight',
      // component: CrisisInsight,
      component: GraphChart,
      meta: {
        tilte: '',
        requiresAuth: false
      }
    },
    {
      path: '/sss',
      name: 'CrisisInsight',
      component: sss,
      meta: {
        tilte: '',
        requiresAuth: false
      }
    },
    {
      path: '/',
      component: EventIndex,
      children: [
        {
          path: '/',
          name: 'EventIndex',
          component: HomePage,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        // {
        //   path: '/',
        //   name: 'EventIndex',
        //   component: SubscribeIndex,
        //   meta: {
        //     tilte: '',
        //     requiresAuth: false
        //   }
        // },
        {
          path: '/crisisTopic',
          name: 'CrisisTopic',
          component: CrisisTopic,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        {
          path: '/crisisDetails',
          name: 'crisisDetails',
          component: CrisisDetails,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        {
          path: '/crisisTopicDetails',
          name: 'CrisisTopicDetails',
          component: CrisisTopicDetails,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        {
          path: '/insight',
          name: 'CrisisInsight',
          component: CrisisInsight,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        {
          path: '/CrisisChart',
          name: 'CrisisChart',
          component: CrisisChart,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        },
        // {
        //   path: 'rank',
        //   name: 'CrisisRank',
        //   component: CrisisRank,
        //   meta: {
        //     tilte: '',
        //     requiresAuth: false
        //   } // 榜单
        // },
        {
          path: 'collect',
          name: 'CaseCollection',
          component: CaseCollection,
          meta: {
            tilte: '',
            requiresAuth: false
          } // 集锦
        },
        {
          path: 'compare',
          name: 'CaseCompare',
          component: CaseCompare,
          meta: {
            tilte: '',
            requiresAuth: false
          } // 对比
        },
        {
          path: 'report',
          name: 'ReportDownload',
          component: ReportDownload,
          meta: {
            tilte: '',
            requiresAuth: false
          } // 报告
        },
        {
          path: 'caliberLibrary',
          name: 'CaliberLibrary',
          component: CaliberLibrary,
          meta: {
            tilte: '',
            requiresAuth: false
          } // 口径库
        },
        {
          path: '/user',
          name: 'UserCenter',
          component: UserCenter, // 个人中心
          meta: {
            title: '',
            requiresAuth: true
          },
          redirect: {
            name: 'MyCase'
          },
          children: [
            {
              path: 'case',
              name: 'MyCase',
              component: MyCase,
              meta: {
                title: '',
                requiresAuth: true
              }
            },
            {
              path: 'report',
              name: 'MyReport',
              component: MyReport,
              meta: {
                title: '',
                requiresAuth: true
              }
            },
            {
              path: 'vip',
              name: 'MyVip',
              component: MyVip,
              meta: {
                title: '',
                requiresAuth: true
              }
            },
            {
              path: 'information',
              name: 'MyInformation',
              component: MyInformation,
              meta: {
                title: '',
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/search',
          name: 'EventSearch',
          component: EventSearch,
          redirect: {
            name: 'KeywordSearch'
          },
          meta: {
            title: '',
            requiresAuth: true
          }, // 事件搜索
          children: [
            {
              path: 'keyword/:keyword?',
              name: 'KeywordSearch',
              component: KeywordSearch
            },
            {
              path: 'tag/:tag?',
              name: 'TagSearch',
              component: TagSearch
            }
          ]
        }
      ]
    },
    {
      path: '/share',
      name: 'share',
      component: ShareLayout,
      meta: {
        tilte: '',
        requiresAuth: false
      },
      children: [
        {
          path: '/share/crisisDetails',
          name: 'crisisDetails',
          component: CrisisDetails,
          meta: {
            tilte: '',
            requiresAuth: false
          }
        }
      ]
    },
    {
      path: '/event/:id',
      name: 'EventCenter',
      component: EventCenter, // 事件首页
      redirect: {
        name: 'EventGeneral'
      },
      meta: {
        title: '',
        requiresAuth: true
      },
      children: [
        {
          path: 'general',
          name: 'EventGeneral',
          component: EventGeneral,
          meta: {
            title: '',
            requiresAuth: true
          } // 事件概览
        },
        {
          path: 'tendency',
          name: 'EventTendency',
          component: EventTendency,
          meta: {
            title: '',
            requiresAuth: true
          } // 传播趋势
        },
        {
          path: 'channel',
          name: 'EventChannel',
          component: EventChannel,
          meta: {
            title: '',
            requiresAuth: true
          } // 渠道分布
        },
        {
          path: 'views',
          name: 'EventViews',
          component: EventViews,
          meta: {
            title: '',
            requiresAuth: true
          } // 媒体观点
        },
        {
          path: 'response',
          name: 'EventResponse',
          component: EventResponse,
          meta: {
            title: '',
            requiresAuth: true
          } // 回应
        },
        {
          path: 'charge',
          name: 'EventCharge',
          component: EventCharge,
          meta: {
            title: '',
            requiresAuth: true
          } //
        }
      ]
    },
    // {
    //   path: '/event/:id',
    //   name: 'EventCenter',
    //   component: EventCenter, // 事件首页
    //   redirect: {
    //     name: 'EventGeneralX'
    //   },
    //   meta: {
    //     title: '',
    //     requiresAuth: true
    //   },
    //   children: [
    //     {
    //       path: 'audiences',
    //       name: 'AudiencesAnalyse',
    //       component: AudiencesAnalyse, // 受众分析
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       }
    //     },
    //     {
    //       path: 'channel',
    //       name: 'ChannelAnalyse',
    //       component: ChannelAnalyse, // 渠道分析
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       }
    //     },
    //     {
    //       path: 'topwords',
    //       name: 'TopwordsLayout',
    //       component: TopwordsLayout,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } // 热词分析
    //     },
    //     {
    //       path: 'general',
    //       name: 'EventGeneralX',
    //       component: EventGeneralX,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } // 事件概览
    //     },
    //     {
    //       path: 'trend',
    //       name: 'EventTrend',
    //       component: EventTrend,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } // 传播趋势
    //     },
    //     {
    //       path: 'charge',
    //       name: 'EventCharge',
    //       component: EventCharge,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } //
    //     },
    //     {
    //       path: 'view',
    //       name: 'ViewLayout',
    //       component: ViewLayout,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } // 观点分布
    //     },
    //     {
    //       path: 'link',
    //       name: 'EventLink',
    //       component: EventLink,
    //       meta: {
    //         title: '',
    //         requiresAuth: true
    //       } // 传播链路
    //     }
    //   ]
    // },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login,
    //   meta: {
    //     title: '',
    //     requiresAuth: false
    //   } // 登录页
    // },
    // {
    //   path: '/register',
    //   name: 'Register',
    //   component: Register,
    //   meta: {
    //     title: '',
    //     requiresAuth: false
    //   }
    // },
    // {
    //   path: '/register/wechat',
    //   name: 'RegisterWechat',
    //   component: RegisterWechat,
    //   meta: {
    //     title: '',
    //     requiresAuth: false
    //   }
    // },
    // {
    //   path: '/retrieve',
    //   name: 'PasswordRetrieve', // 密码找回
    //   component: PasswordRetrieve,
    //   meta: {
    //     title: '',
    //     requiresAuth: false
    //   }
    // },
    {
      path: '/viewerpdf/:id',
      name: 'PdfViewer',
      component: PdfViewer,
      meta: {
        title: '',
        requiresAuth: true
      } // pdf查看
    },
    {
      path: '/viewgraph/:id',
      name: 'ViewSpreadGraph',
      component: ViewSpreadGraph,
      meta: {
        title: '',
        requiresAuth: true
      } // 传播图查看
    },
    {
      path: '/comparisonResult',
      name: 'comparisonResult',
      component: comparisonResult,
      meta: {
        title: '',
        requiresAuth: true
      } // 对比结果
    }
  ]
})

// 路由之前钩子
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 页面需要登录验证
    if (request.checkAuthentication()) {
      // 验证通过 已登录
      next(vm => {
        // console.log(vm)
      })
    } else {
      // 验证未通过
      next({
        name: 'EventIndex'
      })
    }
  } else {
    // 页面无需验证登录
    next(vm => {
      // console.log(vm)
    })
  }
})
// 路由之后钩子
router.afterEach((to, from) => {
  // todo
})

export default router



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js